<div *ngIf="!loading">
  <div class="spinner"></div>
  <p class="text-center" style="color: #777;margin: -70px 0 100px;">Carregando solicitação, por favor aguarde ...
  </p>
</div>

<div *ngIf="loading" class="animated fadeIn">

  <div *ngIf="atualizar == 1">
    <div class="callout callout-info">
      <h4>Não houveram alterações nesta etapa!</h4>
    </div>

    <div class="timeline-body">

      <div class="col-sm-12">

        <div class="col-sm-12">
          <h3>
            <span>Lista das despesas</span>
            <button (click)="calculaResumoDetalhamento()" class="btn btn-primary btn-sm pull-right"
              style="margin-right: 10px;">Ver resumo</button>
          </h3>
          <hr>

          <div class="position-button-floating animated fadeIn text-center">
            <button (click)="calculaResumoDetalhamento()" class="btn btn-primary btn-sm pull-right"
              style="margin-bottom: 10px;">Ver resumo</button>
          </div>

        </div>

        <div class="col-sm-12">
          <div *ngFor="let despesa of listDetalhamentoFinanceiroVigente; let index = index;">
            <div class="col-sm-12">
              <h3><b>Despesa {{index+1}}:</b> &nbsp; {{ despesa.especificacao }}</h3>
              <ul class="tree">
                <li style="color: #777;">Tipo: <b> {{ retornaTipo(despesa.tipo) }}</b></li>
                <li style="color: #777;">Categoria: <b>
                    {{ despesa.categoria ? verificaCategoria(despesa.categoria.id) : 'Não definido' }}</b></li>
                <li style="color: #777;">Valor: <b>
                    {{ calculaDespesa(despesa) | currency:'BRL':'symbol-narrow':'1.2-2' }}</b></li>
              </ul>
              <br>
            </div>



            <div class="col-sm-12">
              <table class="table table-bordered">
                <tbody *ngIf="despesa.tipo == 'Pessoa_horista'">
                  <tr>
                    <th colspan="8">
                      Detalhamento
                    </th>
                  </tr>
                  <tr>
                    <th>Etapa no cronograma</th>
                    <th>Especificação</th>
                    <th class="text-center">UN</th>
                    <th class="text-center">QTD</th>
                    <th>Valor Unitário</th>
                    <th>20% INSS</th>
                    <th>Valor Total</th>
                  </tr>

                  <tr *ngFor="let detalhamento of despesa.detalhamentoFinanceiroHasEtapaCronogramaFisico">
                    <td *ngIf="detalhamento.nomeEtapa">{{ detalhamento.nomeEtapa }}</td>
                    <td *ngIf="!detalhamento.nomeEtapa" style="color: #f70727c7;"> INDEFINIDA </td>
                    <td>{{ detalhamento.especificacao }}</td>
                    <td class="text-center">{{ detalhamento.un }}</td>
                    <td class="text-center">{{ detalhamento.quantidade }}</td>
                    <td>{{ detalhamento.valorUnitario | currency:'BRL':'symbol-narrow':'1.2-2' }}</td>
                    <td>
                      {{ soma20Inss(detalhamento.quantidade, detalhamento.valorUnitario) | currency:'BRL':'symbol-narrow':'1.2-2' }}
                    </td>
                    <td>{{ detalhamento.valorTotal | currency:'BRL':'symbol-narrow':'1.2-2' }}</td>
                  </tr>

                </tbody>

                <tbody *ngIf="despesa.tipo != 'Pessoa_horista' && despesa.tipo != 'Pessoa_celetista'">
                  <tr>
                    <th colspan="7">
                      Detalhamento
                    </th>
                  </tr>
                  <tr>
                    <th>Etapa no cronograma</th>
                    <th>Especificação</th>
                    <th class="text-center">UN</th>
                    <th class="text-center">QTD</th>
                    <th>Valor Unitário</th>
                    <th>Valor Total</th>
                  </tr>

                  <tr *ngFor="let detalhamento of despesa.detalhamentoFinanceiroHasEtapaCronogramaFisico">
                    <td *ngIf="detalhamento.nomeEtapa">{{ detalhamento.nomeEtapa }}</td>
                    <td *ngIf="!detalhamento.nomeEtapa" style="color: #f70727c7;"> INDEFINIDA </td>
                    <td>{{ detalhamento.especificacao }}</td>
                    <td class="text-center">{{ detalhamento.un }}</td>
                    <td class="text-center">{{ detalhamento.quantidade }}</td>
                    <td>{{ detalhamento.valorUnitario | currency:'BRL':'symbol-narrow':'1.2-2' }}</td>
                    <td>{{ detalhamento.valorTotal | currency:'BRL':'symbol-narrow':'1.2-2' }}</td>
                  </tr>

                </tbody>

                <tbody *ngIf="despesa.tipo == 'Pessoa_celetista'">
                  <tr>
                    <th colspan="7">
                      Detalhamento
                    </th>
                  </tr>
                  <tr>
                    <th>Função</th>
                    <th class="text-center">Meses</th>
                    <th class="text-center">QTD</th>
                    <th>Salário</th>
                    <th>Total Unitário</th>
                    <th>Total Geral</th>
                    <th class="text-center" style="min-width: 85px;">Ações</th>
                  </tr>
                  <tr *ngFor="let detalhamento of despesa.detalhamentoFinanceiroHasEtapaCronogramaFisico">
                    <td>{{ detalhamento.funcao }}</td>
                    <td class="text-center">{{ detalhamento.mes }}</td>
                    <td class="text-center">{{ detalhamento.quantidade }}</td>
                    <td>{{ detalhamento.salario | currency:'BRL':'symbol-narrow':'1.2-2'}}</td>
                    <td>{{ detalhamento.totalUnitario | currency:'BRL':'symbol-narrow':'1.2-2' }}</td>
                    <td>{{ detalhamento.valorTotal | currency:'BRL':'symbol-narrow':'1.2-2' }}</td>
                  </tr>
                </tbody>

              </table>

            </div>

            <div class="col-md-12 no-padding" id="despesa-smoth-{{index}}">
              <hr>
            </div>

          </div>
        </div>


      </div>

    </div>

    <div class="callout callout-info">
      <h4>Não houveram alterações nesta etapa!</h4>
    </div>
  </div>

  <mat-tab-group *ngIf="atualizar == 0 || atualizar == 2">
    <mat-tab label="Despesas vigente">
      <div class="timeline-body">

        <div class="col-sm-12">

          <div class="col-sm-12">
            <h3>
              <span>Lista das despesas</span>
              <button (click)="calculaResumoDetalhamento()" class="btn btn-primary btn-sm pull-right"
                style="margin-right: 10px;">Ver resumo</button>
            </h3>
            <hr>

            <div class="position-button-floating animated fadeIn text-center">
              <button (click)="calculaResumoDetalhamento()" class="btn btn-primary btn-sm pull-right"
                style="margin-bottom: 10px;">Ver resumo</button>
            </div>

          </div>

          <div class="col-sm-12">
            <div *ngFor="let despesa of listDetalhamentoFinanceiroVigente; let index = index;">
              <div class="col-sm-12">
                <h3><b>Despesa {{index+1}}:</b> &nbsp; {{ despesa.especificacao }}</h3>
                <ul class="tree">
                  <li style="color: #777;">Tipo: <b> {{ retornaTipo(despesa.tipo) }}</b></li>
                  <li style="color: #777;">Categoria: <b>
                      {{ despesa.categoria ? verificaCategoria(despesa.categoria.id) : 'Não definido' }}</b></li>
                  <li style="color: #777;">Valor: <b>
                      {{ calculaDespesa(despesa) | currency:'BRL':'symbol-narrow':'1.2-2' }}</b></li>
                </ul>
                <br>
              </div>



              <div class="col-sm-12">
                <table class="table table-bordered">
                  <tbody *ngIf="despesa.tipo == 'Pessoa_horista'">
                    <tr>
                      <th colspan="8">
                        Detalhamento
                      </th>
                    </tr>
                    <tr>
                      <th>Etapa no cronograma</th>
                      <th>Especificação</th>
                      <th class="text-center">UN</th>
                      <th class="text-center">QTD</th>
                      <th>Valor Unitário</th>
                      <th>20% INSS</th>
                      <th>Valor Total</th>
                    </tr>

                    <tr *ngFor="let detalhamento of despesa.detalhamentoFinanceiroHasEtapaCronogramaFisico">
                      <td *ngIf="detalhamento.nomeEtapa">{{ detalhamento.nomeEtapa }}</td>
                      <td *ngIf="!detalhamento.nomeEtapa" style="color: #f70727c7;"> INDEFINIDA </td>
                      <td>{{ detalhamento.especificacao }}</td>
                      <td class="text-center">{{ detalhamento.un }}</td>
                      <td class="text-center">{{ detalhamento.quantidade }}</td>
                      <td>{{ detalhamento.valorUnitario | currency:'BRL':'symbol-narrow':'1.2-2' }}</td>
                      <td>
                        {{ soma20Inss(detalhamento.quantidade, detalhamento.valorUnitario) | currency:'BRL':'symbol-narrow':'1.2-2' }}
                      </td>
                      <td>{{ detalhamento.valorTotal | currency:'BRL':'symbol-narrow':'1.2-2' }}</td>
                    </tr>

                  </tbody>

                  <tbody *ngIf="despesa.tipo != 'Pessoa_horista' && despesa.tipo != 'Pessoa_celetista'">
                    <tr>
                      <th colspan="7">
                        Detalhamento
                      </th>
                    </tr>
                    <tr>
                      <th>Etapa no cronograma</th>
                      <th>Especificação</th>
                      <th class="text-center">UN</th>
                      <th class="text-center">QTD</th>
                      <th>Valor Unitário</th>
                      <th>Valor Total</th>
                    </tr>

                    <tr *ngFor="let detalhamento of despesa.detalhamentoFinanceiroHasEtapaCronogramaFisico">
                      <td *ngIf="detalhamento.nomeEtapa">{{ detalhamento.nomeEtapa }}</td>
                      <td *ngIf="!detalhamento.nomeEtapa" style="color: #f70727c7;"> INDEFINIDA </td>
                      <td>{{ detalhamento.especificacao }}</td>
                      <td class="text-center">{{ detalhamento.un }}</td>
                      <td class="text-center">{{ detalhamento.quantidade }}</td>
                      <td>{{ detalhamento.valorUnitario | currency:'BRL':'symbol-narrow':'1.2-2' }}</td>
                      <td>{{ detalhamento.valorTotal | currency:'BRL':'symbol-narrow':'1.2-2' }}</td>
                    </tr>

                  </tbody>

                  <tbody *ngIf="despesa.tipo == 'Pessoa_celetista'">
                    <tr>
                      <th colspan="7">
                        Detalhamento
                      </th>
                    </tr>
                    <tr>
                      <th>Função</th>
                      <th class="text-center">Meses</th>
                      <th class="text-center">QTD</th>
                      <th>Salário</th>
                      <th>Total Unitário</th>
                      <th>Total Geral</th>
                      <th class="text-center" style="min-width: 85px;">Ações</th>
                    </tr>
                    <tr *ngFor="let detalhamento of despesa.detalhamentoFinanceiroHasEtapaCronogramaFisico">
                      <td>{{ detalhamento.funcao }}</td>
                      <td class="text-center">{{ detalhamento.mes }}</td>
                      <td class="text-center">{{ detalhamento.quantidade }}</td>
                      <td>{{ detalhamento.salario | currency:'BRL':'symbol-narrow':'1.2-2'}}</td>
                      <td>{{ detalhamento.totalUnitario | currency:'BRL':'symbol-narrow':'1.2-2' }}</td>
                      <td>{{ detalhamento.valorTotal | currency:'BRL':'symbol-narrow':'1.2-2' }}</td>
                    </tr>
                  </tbody>

                </table>

              </div>

              <div class="col-md-12 no-padding" id="despesa-smoth-{{index}}">
                <hr>
              </div>

            </div>
          </div>


        </div>

      </div>
    </mat-tab>

    <mat-tab label="Despesas com alterações">
      <br>
      <div *ngIf="atualizar == 2" class="callout callout-info">
        <h4>Todas as alterações foram avaliadas!</h4>
      </div>

      <div class="timeline-body">

        <div class="col-sm-12">

          <div class="col-sm-12">
            <h3>
              <span>Lista das despesas</span>
            </h3>
            <hr>

          </div>

          <div class="col-sm-12">
            <div *ngFor="let despesa of listDetalhamentoFinanceiroAlterado; let index = index;">


              <div class="col-sm-12">
                <h3><b>Despesa {{index+1}}:</b> &nbsp; {{ despesa.especificacao }}</h3>

                <div class="col-sm-10">
                  <ul class="tree">
                    <li style="color: #777;">Tipo: <b> {{ retornaTipo(despesa.tipo) }}</b></li>
                    <li style="color: #777;">Categoria: <b>
                        {{ despesa.categoria ? verificaCategoria(despesa.categoria.id) : 'Não definido' }}</b></li>
                    <li style="color: #777;">Valor: <b>
                        {{ calculaDespesa(despesa) | currency:'BRL':'symbol-narrow':'1.2-2' }}</b></li>

                    <span *ngIf="despesa.alteracao != null">
                      <h5><b>Despesa alterada</b></h5>
                      <li style="color: #777;">Tipo de alteração: <b>
                          <span *ngIf="despesa.alteracao.tipoAlteracao == 'Adicionado'">Adicionada</span>
                          <span *ngIf="despesa.alteracao.tipoAlteracao == 'Alterado'">Alterada</span>
                          <span *ngIf="despesa.alteracao.tipoAlteracao == 'Excluido'">Excluída</span>
                        </b></li>
                      <li style="color: #777;">Status:
                        <span *ngIf="despesa.alteracao.statusAlteracao == 'Submetido'" style="font-size: 12px;"
                          class="label label-warning">Não avaliada
                        </span>
                        <span *ngIf="despesa.alteracao.statusAlteracao == 'Aprovado'" style="font-size: 12px;"
                          class="label label-success">Aprovada
                        </span>
                        <span *ngIf="despesa.alteracao.statusAlteracao == 'Reprovado'" style="font-size: 12px;"
                          class="label label-danger">Reprovada
                        </span>
                      </li>
                    </span>
                  </ul>
                </div>
                <div *ngIf="despesa.alteracao != null" class="box-tools col-sm-2">
                  <button (click)="openModalAvaliarDespesa(despesa)" class="btn btn-primary btn-sm  pull-right"
                    style="margin: 3px 0 0 0;"><i class="fa fa-edit"></i>
                    <span *ngIf="despesa.alteracao.statusAlteracao == 'Submetido'">Avaliar</span>
                    <span *ngIf="despesa.alteracao.statusAlteracao != 'Submetido'">Alterar av.</span>
                  </button>&nbsp;&nbsp;
                </div>

              </div>

              <div class="col-sm-12">
                <br>
                <table class="table table-bordered">






                  <tbody *ngIf="despesa.tipo == 'Pessoa_horista'">
                    <tr>
                      <th colspan="8">
                        Detalhamento
                      </th>
                    </tr>
                    <tr>
                      <th>Etapa no cronograma</th>
                      <th>Especificação</th>
                      <th class="text-center">UN</th>
                      <th class="text-center">QTD</th>
                      <th>Valor Unitário</th>
                      <th>20% INSS</th>
                      <th>Valor Total</th>
                    </tr>

                    <tr *ngFor="let detalhamento of despesa.detalhamentoFinanceiroHasEtapaCronogramaFisico">
                      <td *ngIf="detalhamento.nomeEtapa">{{ detalhamento.nomeEtapa }}</td>
                      <td *ngIf="!detalhamento.nomeEtapa" style="color: #f70727c7;"> INDEFINIDA </td>
                      <td>{{ detalhamento.especificacao }}</td>
                      <td class="text-center">{{ detalhamento.un }}</td>
                      <td class="text-center">{{ detalhamento.quantidade }}</td>
                      <td>{{ detalhamento.valorUnitario | currency:'BRL':'symbol-narrow':'1.2-2' }}</td>
                      <td>
                        {{ soma20Inss(detalhamento.quantidade, detalhamento.valorUnitario) | currency:'BRL':'symbol-narrow':'1.2-2' }}
                      </td>
                      <td>{{ detalhamento.valorTotal | currency:'BRL':'symbol-narrow':'1.2-2' }}</td>
                    </tr>

                  </tbody>







                  <tbody *ngIf="despesa.tipo != 'Pessoa_horista' && despesa.tipo != 'Pessoa_celetista'">
                    <tr>
                      <th colspan="9">
                        Detalhamento
                      </th>
                    </tr>
                    <tr>
                      <th>Etapa no cronograma</th>
                      <th>Especificação</th>
                      <th class="text-center">UN</th>
                      <th class="text-center">QTD</th>
                      <th>Valor Unitário</th>
                      <th>Valor Total</th>
                      <th>Tipo alteração</th>
                      <th>Status</th>
                      <th class="text-center" style="width: 85px;">Ação</th>
                    </tr>

                    <tr *ngFor="let detalhamento of despesa.detalhamentoFinanceiroHasEtapaCronogramaFisico">
                      <td *ngIf="detalhamento.nomeEtapa">{{ detalhamento.nomeEtapa }}</td>
                      <td *ngIf="!detalhamento.nomeEtapa" style="color: #f70727c7;"> INDEFINIDA </td>
                      <td>{{ detalhamento.especificacao }}</td>
                      <td class="text-center">{{ detalhamento.un }}</td>
                      <td class="text-center">{{ detalhamento.quantidade }}</td>
                      <td>{{ detalhamento.valorUnitario | currency:'BRL':'symbol-narrow':'1.2-2' }}</td>
                      <td>{{ detalhamento.valorTotal | currency:'BRL':'symbol-narrow':'1.2-2' }}</td>
                      <td class="text-center"> {{ retornaTipoAlteracao(detalhamento.tipoAlteracao) }} </td>


                      <td class="text-center">
                        <span *ngIf="retornaStatusAlteracao(detalhamento) == '-'">-</span>
                        <span *ngIf="retornaStatusAlteracao(detalhamento) == 'Submetida'" style="font-size: 12px;"
                          class="label label-warning">Não avaliada
                        </span>
                        <span *ngIf="retornaStatusAlteracao(detalhamento) == 'Reprovada'" style="font-size: 12px;"
                          class="label label-danger">Reprovada
                        </span>
                        <span *ngIf="retornaStatusAlteracao(detalhamento) == 'Aprovada'" style="font-size: 12px;"
                          class="label label-success">Aprovada
                        </span>
                      </td>



                      <td class="text-center">
                        <button *ngIf="retornaStatusAlteracao(detalhamento) != '-'"
                          (click)="openModalAvaliarAlteracaoDetalhamento(detalhamento)"
                          class="btn btn-primary btn-xs  pull-right" style="margin: 3px 0 0 0;">
                          <i class="fa fa-edit"></i>
                          <span *ngIf="retornaStatusAlteracao(detalhamento) == 'Submetida'">Avaliar</span>
                          <span *ngIf="retornaStatusAlteracao(detalhamento) != 'Submetida'">Alterar Av.</span>
                        </button>
                        <span *ngIf="retornaStatusAlteracao(detalhamento) == '-'">-</span>
                      </td>
                    </tr>

                  </tbody>










                  <tbody *ngIf="despesa.tipo == 'Pessoa_celetista'">
                    <tr>
                      <th colspan="7">
                        Detalhamento
                      </th>
                    </tr>
                    <tr>
                      <th>Função</th>
                      <th class="text-center">Meses</th>
                      <th class="text-center">QTD</th>
                      <th>Salário</th>
                      <th>Total Unitário</th>
                      <th>Total Geral</th>
                      <th class="text-center" style="min-width: 85px;">Ações</th>
                    </tr>
                    <tr *ngFor="let detalhamento of despesa.detalhamentoFinanceiroHasEtapaCronogramaFisico">
                      <td>{{ detalhamento.funcao }}</td>
                      <td class="text-center">{{ detalhamento.mes }}</td>
                      <td class="text-center">{{ detalhamento.quantidade }}</td>
                      <td>{{ detalhamento.salario | currency:'BRL':'symbol-narrow':'1.2-2'}}</td>
                      <td>{{ detalhamento.totalUnitario | currency:'BRL':'symbol-narrow':'1.2-2' }}</td>
                      <td>{{ detalhamento.valorTotal | currency:'BRL':'symbol-narrow':'1.2-2' }}</td>
                    </tr>
                  </tbody>
















                </table>

              </div>

              <div class="col-md-12 no-padding" id="despesa-smoth-{{index}}">
                <hr>
              </div>

            </div>
          </div>


        </div>

      </div>
    </mat-tab>
  </mat-tab-group>

</div>


<!-- MODAIS -->
<p-dialog [style]="{width: '800px', 'min-height': '600px'}" [header]="tituloModalDespesa" [(visible)]="modalAvaliarDespesa" showEffect="fade" [modal]="true">

  <mat-tab-group *ngIf="despesaAlterada">

    <mat-tab label="Antes">
      <br>
      <mat-card>
        <mat-card-header>
          <mat-card-title>
            <h3>{{ avaliarAlteracaoDespesa.especificacaoAntes }}</h3>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ul class="tree">

            <li style="color: #777;">Tipo: <b> {{ retornaTipo(null) }}</b></li>

            <li style="color: #777;">Categoria: <b>
                {{  verificaCategoriaModal() }}</b></li>

            <li style="color: #777;">Valor: <b>
                {{ valorTotalDespesa | currency:'BRL':'symbol-narrow':'1.2-2' }}</b></li>

          </ul>
        </mat-card-content>
      </mat-card>

      <br>

    </mat-tab>

    <mat-tab label="Depois">

      <mat-card>
        <mat-card-header>
          <mat-card-title>
            <h3>{{ avaliarAlteracaoDespesa.especificacaoDepois }}</h3>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ul class="tree">

            <li style="color: #777;">Tipo: <b> {{ retornaTipo(null) }}</b></li>

            <li style="color: #777;">Categoria: <b>
                {{  verificaCategoriaModal() }}</b></li>

            <li style="color: #777;">Valor: <b>
                {{ valorTotalDespesa | currency:'BRL':'symbol-narrow':'1.2-2' }}</b></li>

          </ul>
        </mat-card-content>
      </mat-card>

      <br>

      <div class="callout callout-info">
        <h4>Avaliação da alteração!</h4>

        <form #formAvaliacaoAlteracaoDespesa="ngForm" autocomplete="off" (ngSubmit)="avaliarDespesa()">

          <div class="ui-g-12 ui-fluid">
            <div class="form-group">
              <div class="radio">
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios1" (click)="aprovarAv()">Aprovado
                </label>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios2" (click)="reprovarAv()">Reprovado
                </label>
              </div>
            </div>

          </div>

          <textarea name="observacao" [(ngModel)]="avaliarAlteracaoDespesa.justifAvalAlteracao" class="form-control"
            rows="3" placeholder="Observação ..."></textarea><br>

          <button type="submit" class="btn btn-xs btn-default">AVALIAR</button>

        </form>
      </div>

    </mat-tab>

  </mat-tab-group>

  <mat-tab-group *ngIf="despesaAdicionada">

    <mat-tab label="Despesa adicionada">

      <mat-card>
        <mat-card-header>
          <mat-card-title>
            <h3>{{ avaliarAlteracaoDespesa.especificacaoDepois }}</h3>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ul class="tree">

            <li style="color: #777;">Tipo: <b> {{ retornaTipo(null) }}</b></li>

            <li style="color: #777;">Categoria: <b>
                {{  verificaCategoriaModal() }}</b></li>

            <li style="color: #777;">Valor: <b>
                {{ valorTotalDespesa | currency:'BRL':'symbol-narrow':'1.2-2' }}</b></li>

          </ul>
        </mat-card-content>
      </mat-card>

      <br>

      <div class="callout callout-info">
        <h4>Avaliação da alteração!</h4>

        <form #form="ngForm" autocomplete="off" (ngSubmit)="avaliarDespesa()">

          <div class="ui-g-12 ui-fluid">
            <div class="form-group">
              <div class="radio">
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios1" (click)="aprovarAv()">Aprovado
                </label>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios2" (click)="reprovarAv()">Reprovado
                </label>
              </div>
            </div>

          </div>

          <textarea name="observacao" [(ngModel)]="avaliarAlteracaoDespesa.justifAvalAlteracao" class="form-control"
            rows="3" placeholder="Observação ..."></textarea><br>

          <button type="submit" class="btn btn-xs btn-default">AVALIAR</button>

        </form>
      </div>

    </mat-tab>

  </mat-tab-group>

  <mat-tab-group *ngIf="despesaExcluida">

    <mat-tab label="Despesa excluída">

      <mat-card>
        <mat-card-header>
          <mat-card-title>
            <h3>{{ avaliarAlteracaoDespesa.especificacaoAntes }}</h3>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ul class="tree">

            <li style="color: #777;">Tipo: <b> {{ retornaTipo(null) }}</b></li>

            <li style="color: #777;">Categoria: <b>
                {{  verificaCategoriaModal() }}</b></li>

            <li style="color: #777;">Valor: <b>
                {{ valorTotalDespesa | currency:'BRL':'symbol-narrow':'1.2-2' }}</b></li>

          </ul>
        </mat-card-content>
      </mat-card>

      <br>

      <div class="callout callout-info">
        <h4>Avaliação da alteração!</h4>

        <form #form="ngForm" autocomplete="off" (ngSubmit)="avaliarDespesa()">

          <div class="ui-g-12 ui-fluid">
            <div class="form-group">
              <div class="radio">
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios1" (click)="aprovarAv()">Aprovado
                </label>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios2" (click)="reprovarAv()">Reprovado
                </label>
              </div>
            </div>

          </div>

          <textarea name="observacao" [(ngModel)]="avaliarAlteracaoDespesa.justifAvalAlteracao" class="form-control"
            rows="3" placeholder="Observação ..."></textarea><br>

          <button type="submit" class="btn btn-xs btn-default">AVALIAR</button>

        </form>
      </div>

    </mat-tab>

  </mat-tab-group>

</p-dialog>


<p-dialog [style]="{width: '800px', 'min-height': '600px'}" [header]="tituloModalDetalhamento" [(visible)]="modalDetalhamentoAlterado" showEffect="fade" [modal]="true">

  <mat-tab-group *ngIf="detalhamentoaAlterado">

    <mat-tab label="Antes">
      <br>

      <mat-card>
        <mat-card-header>
          <mat-card-title>
            <h3>{{ avaliarAlteracaoDetalhamento.especificacaoAntes }}</h3>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ul class="tree">

            <li style="color: #777;">UN: <b> {{ avaliarAlteracaoDetalhamento.unAntes }}</b></li>

            <li style="color: #777;">QTD: <b>
                {{  avaliarAlteracaoDetalhamento.quantidadeAntes }}</b></li>

            <li style="color: #777;">Valor unitário: <b>
                {{ avaliarAlteracaoDetalhamento.valorUnitarioAntes | currency:'BRL':'symbol-narrow':'1.2-2' }}</b></li>

            <li style="color: #777;">Valor total: <b>
                {{ avaliarAlteracaoDetalhamento.valorTotalAntes | currency:'BRL':'symbol-narrow':'1.2-2' }}</b></li>

          </ul>
        </mat-card-content>
      </mat-card>

      <br>

    </mat-tab>

    <mat-tab label="Depois">

      <mat-card>
        <mat-card-header>
          <mat-card-title>
            <h3>{{ avaliarAlteracaoDetalhamento.especificacaoDepois }}</h3>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <ul class="tree">

            <li style="color: #777;">UN: <b> {{ avaliarAlteracaoDetalhamento.unDepois }}</b></li>

            <li style="color: #777;">QTD: <b>
                {{  avaliarAlteracaoDetalhamento.quantidadeDepois }}</b></li>

            <li style="color: #777;">Valor unitário: <b>
                {{ avaliarAlteracaoDetalhamento.valorUnitarioDepois | currency:'BRL':'symbol-narrow':'1.2-2' }}</b></li>

            <li style="color: #777;">Valor total: <b>
                {{ avaliarAlteracaoDetalhamento.valorTotalDepois | currency:'BRL':'symbol-narrow':'1.2-2' }}</b></li>

          </ul>
        </mat-card-content>
      </mat-card>

      <br>

      <div class="callout callout-info">
        <h4>Avaliação da alteração!</h4>
        <form #formAvaliacaoAlteracaoDetalhamento="ngForm" autocomplete="off"
          (ngSubmit)="avaliarDetalhamentoAlterado()">

          <div class="ui-g-12 ui-fluid">
            <div class="form-group">
              <div class="radio">
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios1" (click)="aprovarAv()">Aprovado
                </label>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios2" (click)="reprovarAv()">Reprovado
                </label>
              </div>
            </div>

          </div>

          <textarea name="observacao" [(ngModel)]="avaliarAlteracaoDetalhamento.justifAvalAlteracao"
            class="form-control" rows="3" placeholder="Observação ..."></textarea><br>

          <button type="submit" class="btn btn-xs btn-default">AVALIAR</button>

        </form>
      </div>

    </mat-tab>

  </mat-tab-group>

  <mat-tab-group *ngIf="detalhamentoAdicionado">

    <mat-tab label="Detalhamento adicionado">

      <mat-card>
        <h5 style="color: #999;">Teste Add:</h5>
      </mat-card>


      <br>

      <div class="callout callout-info">
        <h4>Avaliação da alteração!</h4>

        <form #formAvaliacaoAdicaoDetalhamento="ngForm" autocomplete="off" (ngSubmit)="avaliarDetalhamentoAlterado()">

          <div class="ui-g-12 ui-fluid">
            <div class="form-group">
              <div class="radio">
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios1" (click)="aprovarAv()">Aprovado
                </label>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios2" (click)="reprovarAv()">Reprovado
                </label>
              </div>
            </div>

          </div>

          <textarea name="observacao" [(ngModel)]="avaliarAlteracaoDetalhamento.justifAvalAlteracao"
            class="form-control" rows="3" placeholder="Observação ..."></textarea><br>

          <button type="submit" class="btn btn-xs btn-default">AVALIAR</button>

        </form>
      </div>

    </mat-tab>

  </mat-tab-group>

  <mat-tab-group *ngIf="detalhamentoExcluido">

    <mat-tab label="Detalhamento excluído">

      <mat-card>
        <h5 style="color: #999;">Teste excluído:</h5>
      </mat-card>


      <br>

      <div class="callout callout-info">
        <h4>Avaliação da alteração!</h4>

        <form #formAvaliacaoExclusaoDetalhamento="ngForm" autocomplete="off" (ngSubmit)="avaliarDetalhamentoAlterado()">

          <div class="ui-g-12 ui-fluid">
            <div class="form-group">
              <div class="radio">
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios1" (click)="aprovarAv()">Aprovado
                </label>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <label>
                  <input type="radio" name="optionsRadios" id="optionsRadios2" (click)="reprovarAv()">Reprovado
                </label>
              </div>
            </div>

          </div>

          <textarea name="observacao" [(ngModel)]="avaliarAlteracaoDetalhamento.justifAvalAlteracao"
            class="form-control" rows="3" placeholder="Observação ..."></textarea><br>

          <button type="submit" class="btn btn-xs btn-default">AVALIAR</button>

        </form>
      </div>

    </mat-tab>

  </mat-tab-group>

</p-dialog>